webpackJsonp([40124410918716],{

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Vladik-Khononov.187ed50d.jpg";

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VladikKhononov = __webpack_require__(122);
	
	var _VladikKhononov2 = _interopRequireDefault(_VladikKhononov);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VladikKhononov = function VladikKhononov() {
	  return _react2.default.createElement(
	    'section',
	    { id: 'speaker', className: 'parallax-section' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 col-sm-12 wow fadeInUp', 'data-wow-delay': '0.1s' },
	          _react2.default.createElement(
	            'div',
	            { className: 'team-wrapper' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Vladik Khononov'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement('img', { src: _VladikKhononov2.default, className: 'img-responsive', alt: 'Vladik Khononov' }),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'social-icon' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement('a', { href: 'https://www.linkedin.com/in/vladikk/', target: '_blank', className: 'fa fa-linkedin wow fadeIn' })
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement('a', { href: 'https://twitter.com/vladikk', target: '_blank', className: 'fa fa-twitter wow fadeIn' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-5' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Vladik (Vlad) Khononov is a software engineer with over 15 years of industry experience, during which he has worked for companies large and small in roles ranging from webmaster to chief architect. Vlad is a long-time proponent of domain-driven design and evolutionary architecture and currently helps companies make sense of their business domains, untangle monoliths, and tackle complex architectural challenges.',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  'Vlad maintains an active media career as a public speaker and blogger. He has spoken at numerous industry conferences \u2014 including O\u2019Reilly Software Architecture, DDD Europe, and NDC \u2014 about subjects such as domain-driven design, microservices, and software architecture in general. In addition to his media work, he co-organizes the Domain-Driven Design Israel and Tel Aviv Software Architecture meetup groups.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Talk: Microservices, bounded contexts, and everything in between'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  '\u201CNinety-five percent of the words are spent extolling the benefits of \u2018modularity\u2019 and that little, if anything, is said about how to achieve it\u201D\u2014Glenford J. Myers, 1978.'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'The above quote is 40 years old. Today, four decades later, nothing has changed except terminology. Time to fix this.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Vladik Khononov explains how to decompose a system into loosely coupled components: how to draw boundaries between services, how to decide whether some logic belongs to one service or another, and how domain-driven design can help us make those decisions. Finally, he takes a stab at answering the age-old question of what part of a microservice should be \u201Cmicro\u201D and how it can be measured.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'You\u2019ll hear about neither Docker nor Kubernetes. Actually, nothing related to infrastructure. Instead, you\u2019ll dive into the difference between microservices and bounded contexts, discover when each pattern should be used, and get takeaways from Vladik\u2019s experience optimizing microservices-quotebased architectures at Naxex.'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = VladikKhononov;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-speakers-vladik-khononov-js-f0f855967f4e72bf66e6.js